import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { AccountService } from '../auth/account.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CustomerProfiles } from '@supoui/shared/model/customerProfiles';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
@UntilDestroy({ checkProperties: true })
export class CustomerProfileService {
  private cachedAllCustomerProfiles = new ReplaySubject<CustomerProfiles[]>(1);
  private cachedAllCustomerProfilesSize = 0;
  private cachedAllCustomerProfilesLoading = false;

  private authSubscription: Subscription;

  constructor(private http: HttpClient, private accountService: AccountService) {
    this.authSubscription = this.accountService.getAuthenticationState().subscribe(account => {
      this.resetCache();
    });
  }

  getCustomerProfiles(): Observable<CustomerProfiles[]> {
    if (!this.cachedAllCustomerProfilesLoading && this.cachedAllCustomerProfilesSize === 0) {
      this.cachedAllCustomerProfilesLoading = true;
      this.http.get<CustomerProfiles[]>('services/supo-user-administration/api/customer-profiles').subscribe(response => {
        this.cachedAllCustomerProfilesSize = response.length;
        this.cachedAllCustomerProfilesLoading = false;
        this.cachedAllCustomerProfiles.next(response);
      });
    }
    return this.cachedAllCustomerProfiles;
  }

  private resetCache() {
    this.cachedAllCustomerProfilesSize = 0;
  }
}
